/* eslint-disable */
// This file is auto generated, do not edit!

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSJSON: { input: unknown; output: unknown; }
  Long: { input: number; output: number; }
};

export type AccountGender =
  | 'female'
  | 'male';

export type AccountInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<AccountGender>;
  lastName: Scalars['String']['input'];
  locale: Locale;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
};

export type LinkLoyaltyAccountInput = {
  memberId: Scalars['String']['input'];
  memberPin: Scalars['String']['input'];
};

export type Locale =
  | 'ar'
  | 'en';

export type OnboardInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<AccountGender>;
  lastName: Scalars['String']['input'];
  locale: Locale;
  loyaltyMemberId?: InputMaybe<Scalars['String']['input']>;
  loyaltyMemberPin?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  saudiRewardsMemberId?: InputMaybe<Scalars['String']['input']>;
  saudiRewardsMemberPin?: InputMaybe<Scalars['String']['input']>;
};

export type AccountFragment = { firstName: string, lastName: string, middleName?: string | undefined, email: string, gender?: AccountGender | undefined, countryCode: string, city?: string | undefined, locale: string, phoneNumber?: string | undefined, saudiRewardsMemberId?: string | undefined };

export type AddressFragment = { id: string, address1: string, address2?: string | undefined, city: string, countryCode: string, postalCode: string, stateOrProvince?: string | undefined };

export type CreateAddressMutationVariables = Exact<{
  input: AddressInput;
}>;


export type CreateAddressMutation = { createAddress: AddressFragment };

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountMutation = { deleteAccount?: { _?: boolean | undefined } | undefined };

export type DeleteLinkedSaudiRewardsAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteLinkedSaudiRewardsAccountMutation = { deleteLinkedLoyaltyAccount?: { _?: boolean | undefined } | undefined };

export type LinkSaudiRewardsAccountMutationVariables = Exact<{
  input: LinkLoyaltyAccountInput;
}>;


export type LinkSaudiRewardsAccountMutation = { linkLoyaltyAccount: { memberId: string } };

export type MarkUnsupportedDeviceMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkUnsupportedDeviceMutation = { markUnsupportedDevice?: { _?: boolean | undefined } | undefined };

export type OnboardAccountMutationVariables = Exact<{
  input: OnboardInput;
}>;


export type OnboardAccountMutation = { onboard: AccountFragment };

export type RetroRedeemSaudiRewardsPointsMutationVariables = Exact<{
  redeemToken: Scalars['String']['input'];
}>;


export type RetroRedeemSaudiRewardsPointsMutation = { retroRedeemSaudiRewardsPoints?: { _?: boolean | undefined } | undefined };

export type UpdateAccountMutationVariables = Exact<{
  input: AccountInput;
}>;


export type UpdateAccountMutation = { updateAccount: AccountFragment };

export type UpdateAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AddressInput;
}>;


export type UpdateAddressMutation = { updateAddress: AddressFragment };

export type SaudiRewardsBalanceQueryVariables = Exact<{
  memberPin: Scalars['String']['input'];
}>;


export type SaudiRewardsBalanceQuery = { loyaltyBalance: { balance: number, memberId: string, verificationToken: string, verificationTokenExpiration: number } };

export type GetAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountQuery = { account: AccountFragment };

export type GetAccountAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountAddressesQuery = { addresses: Array<AddressFragment> };

export type SaudiRewardsRetroRedeemMatchingOrderFragment = { id: string, eventId: string, itemsCount: number, totalPrice: number, timeslotIds: Array<string> };

export type GetSaudiRewardsRetroRedeemMatchingOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSaudiRewardsRetroRedeemMatchingOrdersQuery = { saudiRewardsRetroRedeemMatchingOrders: Array<SaudiRewardsRetroRedeemMatchingOrderFragment> };

export type GetSaudiRewardsRetroRedeemUserQueryVariables = Exact<{
  redeemToken: Scalars['String']['input'];
}>;


export type GetSaudiRewardsRetroRedeemUserQuery = { saudiRewardsRetroRedeemUser: { existingAccount: boolean, redeemEmail: string } };

export const AccountFragmentDoc = gql`
    fragment Account on Account {
  firstName
  lastName
  middleName
  email
  gender
  countryCode
  city
  locale
  phoneNumber
  saudiRewardsMemberId
}
    ` as unknown as DocumentNode<AccountFragment, unknown>;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  id
  address1
  address2
  city
  countryCode
  postalCode
  stateOrProvince
}
    ` as unknown as DocumentNode<AddressFragment, unknown>;
export const SaudiRewardsRetroRedeemMatchingOrderFragmentDoc = gql`
    fragment SaudiRewardsRetroRedeemMatchingOrder on SaudiRewardsRetroRedeemMatchingOrder {
  id
  eventId
  itemsCount
  totalPrice
  timeslotIds
}
    ` as unknown as DocumentNode<SaudiRewardsRetroRedeemMatchingOrderFragment, unknown>;
export const CreateAddressDocument = gql`
    mutation createAddress($input: AddressInput!) {
  createAddress(input: $input) {
    ...Address
  }
}
    ${AddressFragmentDoc}` as unknown as DocumentNode<CreateAddressMutation, CreateAddressMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount {
  deleteAccount {
    _
  }
}
    ` as unknown as DocumentNode<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const DeleteLinkedSaudiRewardsAccountDocument = gql`
    mutation deleteLinkedSaudiRewardsAccount {
  deleteLinkedLoyaltyAccount {
    _
  }
}
    ` as unknown as DocumentNode<DeleteLinkedSaudiRewardsAccountMutation, DeleteLinkedSaudiRewardsAccountMutationVariables>;
export const LinkSaudiRewardsAccountDocument = gql`
    mutation linkSaudiRewardsAccount($input: LinkLoyaltyAccountInput!) {
  linkLoyaltyAccount(input: $input) {
    memberId
  }
}
    ` as unknown as DocumentNode<LinkSaudiRewardsAccountMutation, LinkSaudiRewardsAccountMutationVariables>;
export const MarkUnsupportedDeviceDocument = gql`
    mutation markUnsupportedDevice {
  markUnsupportedDevice {
    _
  }
}
    ` as unknown as DocumentNode<MarkUnsupportedDeviceMutation, MarkUnsupportedDeviceMutationVariables>;
export const OnboardAccountDocument = gql`
    mutation onboardAccount($input: OnboardInput!) {
  onboard(input: $input) {
    ...Account
  }
}
    ${AccountFragmentDoc}` as unknown as DocumentNode<OnboardAccountMutation, OnboardAccountMutationVariables>;
export const RetroRedeemSaudiRewardsPointsDocument = gql`
    mutation retroRedeemSaudiRewardsPoints($redeemToken: String!) {
  retroRedeemSaudiRewardsPoints(redeemToken: $redeemToken) {
    _
  }
}
    ` as unknown as DocumentNode<RetroRedeemSaudiRewardsPointsMutation, RetroRedeemSaudiRewardsPointsMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation updateAccount($input: AccountInput!) {
  updateAccount(input: $input) {
    ...Account
  }
}
    ${AccountFragmentDoc}` as unknown as DocumentNode<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation updateAddress($id: ID!, $input: AddressInput!) {
  updateAddress(id: $id, input: $input) {
    ...Address
  }
}
    ${AddressFragmentDoc}` as unknown as DocumentNode<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const SaudiRewardsBalanceDocument = gql`
    query saudiRewardsBalance($memberPin: String!) {
  loyaltyBalance(memberPin: $memberPin) {
    balance
    memberId
    verificationToken
    verificationTokenExpiration
  }
}
    ` as unknown as DocumentNode<SaudiRewardsBalanceQuery, SaudiRewardsBalanceQueryVariables>;
export const GetAccountDocument = gql`
    query getAccount {
  account {
    ...Account
  }
}
    ${AccountFragmentDoc}` as unknown as DocumentNode<GetAccountQuery, GetAccountQueryVariables>;
export const GetAccountAddressesDocument = gql`
    query getAccountAddresses {
  addresses {
    ...Address
  }
}
    ${AddressFragmentDoc}` as unknown as DocumentNode<GetAccountAddressesQuery, GetAccountAddressesQueryVariables>;
export const GetSaudiRewardsRetroRedeemMatchingOrdersDocument = gql`
    query getSaudiRewardsRetroRedeemMatchingOrders {
  saudiRewardsRetroRedeemMatchingOrders {
    ...SaudiRewardsRetroRedeemMatchingOrder
  }
}
    ${SaudiRewardsRetroRedeemMatchingOrderFragmentDoc}` as unknown as DocumentNode<GetSaudiRewardsRetroRedeemMatchingOrdersQuery, GetSaudiRewardsRetroRedeemMatchingOrdersQueryVariables>;
export const GetSaudiRewardsRetroRedeemUserDocument = gql`
    query getSaudiRewardsRetroRedeemUser($redeemToken: String!) {
  saudiRewardsRetroRedeemUser(redeemToken: $redeemToken) {
    existingAccount
    redeemEmail
  }
}
    ` as unknown as DocumentNode<GetSaudiRewardsRetroRedeemUserQuery, GetSaudiRewardsRetroRedeemUserQueryVariables>;